/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";
export const GET_SHELF_DETAIL = gql`
  query GetBoxes(
    $filter: BoxFilterInput
    $distFilter: DistCentFilterInput
    $shelfFilter: UniqShelfFilterInput!
  ) {
    getShelf(filter: $shelfFilter) {
      activeStatus
      boxesCount
      createdAt
      id
      name
      shelfDeliveryStatus
      shelfId
      distCent {
        distCenterId
        name
        id
      }
    }

    getMetadata {
      isMoveToShelfEnabled
    }

    getBoxes(filter: $filter) {
      count
      content {
        costumeID
        id
        masqID
        user {
          email
          firstName
          fullName
          id
          lastName
        }
      }
    }

    getDistCents(filter: $distFilter) {
      content {
        distCenterId
        id
        name
        noOfCounters
        band {
          id
          name
          shelves {
            name
            id
            shelfId
          }
        }
      }
    }
  }
`;
